import React, { useEffect, useState } from "react";
import { Button, Card } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import TopBarHome from "../components/TopBarHome";
import pusher from "../services/pusherConfig";
import { LoadingOutlined } from "@ant-design/icons";
import { setBackToPratica } from "../services/api";
const { innerWidth, innerHeight } = window;

const VerificaMobile = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [cliente, setCliente] = useState('');

    useEffect(() => {
        listenBroadcast();
        if (state && state.cliente) {
            setCliente(state.cliente);
        }
    }, [])

    const backToPratica = () => {
        setBackToPratica(localStorage.getItem('id_pratica'), localStorage.getItem('token'));
        navigate('/onboarding');
    }

    const listenBroadcast = () => {
        const idPratica = localStorage.getItem('id_pratica');
        try {
            let c = pusher.subscribe(idPratica);
            c.bind("refreshSezione", function (data) {
                // fetchRegole();
                navigate('/onboarding');
            });
        } catch (error) {
        }

    };

    return (
        <TopBarHome>
            <div className="pol-content" >
                <div style={{
                    color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 18 : 24, marginLeft: 15, marginRight: 15,
                    marginBottom: 60, marginTop: 50, display: 'flex', justifyContent: 'center', textAlign: 'center'
                }}>
                    Continua la verifica dal tuo Smartphone
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', padding: 20, alignItems: 'center', justifyContent: 'center' }}>
                    <Card
                        bordered={false}
                        style={{
                            width: innerWidth < 500 ? 300 : 420,
                            borderRadius: 20,
                            borderColor: '#003897',
                            backgroundColor: '#EFF4FD',
                            boxShadow: "-3px 3px 10px #d2d6df"
                        }}
                    >
                        <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 30 }} >
                            <span>{cliente}</span>, ti abbiamo inviato un sms con un link per continuare la fase di registrazione sul tuo smartphone.
                            <br />
                            Non appena avrai completato le fasi di riconoscimento e caricamento dei documenti,
                            questa pagina si aggiornerà e potrai così ultimare il processo di apertura del conto corrente.
                            <br/>
                            <br/>
                            Ricordati di non chiudere questa pagina finchè non avrai terminato il processo
                        </div>
                        <br />
                        <div style={{display:'flex', justifyContent:'center', marginBottom:'40px'}}>
                            <LoadingOutlined style={{ fontSize: "64px", color: "#023AAE" }} />
                        </div>
                    </Card>
                    <div>
                    
                        
                    </div>
                </div>

                {<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20, marginBottom: 20 }}>

                    <Button
                        type="primary"
                        style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20, width: 200 }}
                        onClick={() => {
                            backToPratica();
                        }}
                    >Ritorna alla Pratica</Button>
                </div>}
            </div>
        </TopBarHome >
    );
};

export default VerificaMobile;
